export default __webpack_public_path__ + "386a917c39e48f6fdeae9a4e7f03170b.png";